(function () {
  var ROOT = '.bnexo-header__nav';
  var TEXT_SELECTOR = '.submenu__item > span > span:first-child';

  function splitWaveText(node) {
    if (!node || node.dataset.bnexoWaveReady) return;

    var text = node.textContent;
    if (!text || !text.trim()) return;

    node.dataset.bnexoWaveReady = 'true';
    node.textContent = '';
    node.classList.add('bnexo-wave-text');

    Array.from(text).forEach(function (char) {
      var span = document.createElement('span');
      span.className = 'bnexo-wave-char';
      span.textContent = char === ' ' ? '\u00a0' : char;
      node.appendChild(span);
    });
  }

  function runWave(link) {
    var chars = link.querySelectorAll('.bnexo-wave-char');
    chars.forEach(function (char) {
      char.classList.remove('is-wave');
    });

    chars.forEach(function (char, index) {
      window.setTimeout(function () {
        char.classList.add('is-wave');
      }, index * 34);
    });
  }

  function resetWave(link) {
    link.querySelectorAll('.bnexo-wave-char').forEach(function (char) {
      char.classList.remove('is-wave');
    });
  }

  function bindLink(link) {
    if (link.dataset.bnexoWaveBound) return;

    var textNode = link.querySelector(':scope > span > span:first-child');
    if (!textNode) return;

    splitWaveText(textNode);
    link.dataset.bnexoWaveBound = 'true';

    link.addEventListener('mouseenter', function () {
      runWave(link);
    });
    link.addEventListener('mouseleave', function () {
      resetWave(link);
    });
    link.addEventListener('focusin', function () {
      runWave(link);
    });
    link.addEventListener('focusout', function () {
      resetWave(link);
    });
  }

  function init() {
    var nav = document.querySelector(ROOT);
    if (!nav) return;

    nav.querySelectorAll('.submenu__item').forEach(bindLink);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
